// extracted by mini-css-extract-plugin
module.exports = {"App":"NavItem_App__1Y0fI","NavItem":"NavItem_NavItem__2AtG7","NavIcon":"NavItem_NavIcon__WoG1l","active":"NavItem_active__1pFNt"};